import { _ } from './internal/constants';
import { isString } from './internal/inspect';
import { newify } from './internal/newify';
import { TRexObservable } from './TRexObservable';
import { defaultTimer } from './internal/defaultTimer';
import { addAll, removeAll, toArray } from './internal/arrays';
import { minMax } from './internal/math';
import { coalesce } from './internal/colesce';
export function TweenRex(opts) {
    var options = (opts || {});
    var self = newify(this, TweenRex);
    self._opts = options;
    self._timer = options.timer || defaultTimer;
    self._pos = options.duration || 0;
    self._time = 0;
    self.labels = options.labels || {};
    self.easing = options.easing;
    self.playbackRate = 1;
    self._tick = function (timestamp) {
        var delta = options.frameSize || (timestamp - (self._last || timestamp)) * self.playbackRate;
        var n = self._time + delta;
        self._last = timestamp;
        self.seek(n);
    };
    var obs = TRexObservable(options);
    self.dispose = function () {
        self.pause();
        self._pos = 0;
        self._time = 0;
        self.playbackRate = 1;
        self._tweens = _;
        self.labels = {};
        obs.dispose();
    };
    self.next = obs.next;
    self.value = obs.value;
    self.subscribe = obs.subscribe;
    return self;
}
TweenRex.prototype = {
    get duration() {
        var self = this;
        var tweens = self._tweens;
        var maxSize = self._pos;
        if (tweens) {
            for (var i = 0, ilen = tweens.length; i < ilen; i++) {
                var t = tweens[i];
                var size = t.pos + t.tween.duration;
                if (maxSize < size) {
                    maxSize = size;
                }
            }
        }
        return maxSize;
    },
    set duration(value) {
        this._pos = value;
    },
    get currentTime() {
        return this._time;
    },
    set currentTime(time) {
        this.seek(time);
    },
    get isPlaying() {
        return !!this._sub;
    },
    add: function (tweens, opts) {
        var self = this;
        if (!self._tweens) {
            self._tweens = [];
        }
        tweens = toArray(tweens);
        var _tweens = self._tweens;
        opts = opts || {};
        var pos = coalesce(isString(opts.position) ? self.labels[opts.position] : opts.position, self.duration);
        var seq = opts.sequence;
        var stagger = opts.stagger;
        var ilen = tweens.length;
        var tweenObjs = Array(ilen);
        for (var i = 0; i < ilen; i++) {
            var tween = ensureTween(tweens[i]);
            if (tween.isPlaying) {
                tween.pause();
            }
            tween._timer = _;
            tweenObjs[i] = { pos: pos, tween: tween };
            if (seq) {
                pos += tween.duration;
            }
            if (stagger) {
                pos += stagger;
            }
        }
        addAll(_tweens, tweenObjs);
        return function () {
            removeAll(_tweens, tweenObjs);
        };
    },
    play: function () {
        var self = this;
        var timer = self._timer;
        if (timer && !self.isPlaying) {
            var isForwards = self.playbackRate >= 0;
            var duration = self.duration;
            var n = self._time;
            if (isForwards && n >= duration) {
                n = 0;
            }
            else if (!isForwards && n <= 0) {
                n = duration;
            }
            self.seek(n);
            self._sub = timer.subscribe(self._tick);
            if (self._opts.onPlay) {
                self._opts.onPlay();
            }
        }
        return self;
    },
    restart: function () {
        var self = this;
        return self
            .pause()
            .seek(self.playbackRate >= 0 ? 0 : self.duration)
            .play();
    },
    pause: function () {
        var self = this;
        var sub = self._sub;
        if (sub) {
            sub();
            self._sub = self._last = _;
            if (self._opts.onPause) {
                self._opts.onPause();
            }
        }
        return self;
    },
    reverse: function () {
        this.playbackRate *= -1;
        return this;
    },
    seek: function (n) {
        var self = this;
        var isForwards = self.playbackRate >= 0;
        var wasPlaying = self.isPlaying;
        var duration = self.duration;
        var c = isString(n) ? self.labels[n] : n;
        var isAtEnd;
        if (isForwards && c >= duration) {
            c = duration;
            self.pause();
            isAtEnd = true;
        }
        else if (!isForwards && c <= 0) {
            c = 0;
            self.pause();
            isAtEnd = true;
        }
        self._time = c;
        var offset = c / (duration || 1);
        if (self.easing) {
            offset = self.easing(offset);
        }
        if (isAtEnd && wasPlaying && self._opts.onFinish) {
            self._opts.onFinish();
        }
        var isSeekingBackward = c < self.value();
        self.next(offset);
        var tweens = self._tweens;
        if (tweens) {
            var d_1 = duration - c;
            tweens.sort(function (a, b) { return (d_1 + a.pos) % duration - (d_1 + b.pos) % duration; });
            if (isSeekingBackward) {
                tweens.reverse();
            }
            for (var i = 0, ilen = tweens.length; i < ilen; i++) {
                var t = tweens[i];
                var tween = t.tween;
                var startPos = t.pos;
                var endPos = startPos + (tween.duration || 1);
                var ro = minMax((c - startPos) / (endPos - startPos), 0, 1);
                tween.next(ro);
            }
        }
        return self;
    },
    getLabel: function (name) {
        return this.labels[name];
    },
    setLabel: function (name, time) {
        this.labels[name] = time;
        return this;
    }
};
function ensureTween(opts) {
    return opts instanceof TweenRex
        ? opts
        : TweenRex(opts);
}
